import { render, staticRenderFns } from "./trendList.vue?vue&type=template&id=b3f9f5ec&scoped=true&"
import script from "./trendList.vue?vue&type=script&lang=js&"
export * from "./trendList.vue?vue&type=script&lang=js&"
import style0 from "./trendList.vue?vue&type=style&index=0&id=b3f9f5ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f9f5ec",
  null
  
)

export default component.exports